import React from "react";
import styles from "./ColoredButton.module.css";

const ColoredButton = ({
  color,
  title,
  handleOnClick,
  icon,
  rounded,
  backgroundColor,
}) => {
  return (
    <div
      style={{
        color: color,
        borderRadius: rounded ? "25px" : "0px",
        backgroundColor: backgroundColor,
      }}
      className={styles["colored-button"]}
      onClick={handleOnClick}
    >
      {icon && <img src={icon} alt='icon' />}
      <h3>{title}</h3>
    </div>
  );
};

export default ColoredButton;
